export const QUESTIONS = {
    1: {
        title: 'loan_question6_title',
        content: 'loan_question6_content',
        link: '/post/exploring-arbitrage-opportunities-with-crypto-loans-blt0c8008549ddb3d0e/',
    },
    2: {
        title: 'loan_question7_title',
        content: 'loan_question7_content',
        link: '/post/level-up-your-derivatives-game-with-crypto-loans-blt6f2743d239fe5ec9/',
    },
    3: {
        title: 'loan_question1_title',
        content: 'FAQNewTips',
        link: '',
    },
    4: {
        title: 'loan_question2_title',
        content: 'loan_question2_detail',
        link: '',
    },
    5: {
        title: 'loan_question3_title',
        content: 'loan_question3_detail',
        link: '',
    },
    6: {
        title: 'loan_question4_title',
        content: 'loan_question4_detail',
        link: '',
    },
    7: {
        title: 'loan_question5_title',
        content: 'ReduceLoanTip4',
        link: '',
    },
};
